import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { StorageMap } from '@ngx-pwa/local-storage';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private storage: StorageMap
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // ถ้ามี token จาก ThaiID ให้ผ่านไปทำงานที่ AuthGuard
    if (route.queryParams['token'] && route.queryParams['refresh_token']) {
      return true;
    }

    // ถ้าเป็น root path
    if (state.url === '/' || state.url === '') {
      return this.storage.get('token').pipe(
        map(token => {
          if (!token) {
            this.router.navigate(['/sessions/signinv2']);
            return false;
          }
          return true;
        })
      );
    }
    
    return true;
  }
}